import React from 'react';
import PageHeader from "../../components/PageHeader";
import UpdateProfile from './profile/UpdateProfile';
import ChangePassword from './profile/ChangePassword';

const MyProfile = () => {

    return (
        <>
            <PageHeader name="Profile" />

            <div className="main-container container-fluid">
                {/* ROW-1 */}
                <div className="row">
                    {/* <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-5">
                        <div className="card text-center shadow-none border profile-cover__img">
                            <div className="card-body">
                                <div className="profile-img-1">
                                    <img
                                        src="build/assets/images/users/18.jpg"
                                        alt="img"
                                        id="profile-img"
                                    />
                                    <a
                                        aria-label="anchor"
                                        href="#"
                                        className="rounded-pill avatar-icons bg-primary tx-fixed-white p-2"
                                    >
                                        <input
                                            type="file"
                                            name="photo"
                                            className="position-absolute w-100 h-100 op-0"
                                            id="profile-change"
                                        />
                                        <i className="fe fe-camera lh-base" />
                                    </a>
                                </div>
                                <div className="profile-img-content text-dark my-2">
                                    <div>
                                        <h5 className="mb-0">Cedric Kelly</h5>
                                        <p className="text-muted mb-0">UI Developer</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="text-warning mb-0">
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star-half-o fs-20" />
                                    </div>
                                </div>
                                <p className="mb-2">(3145 Reviews)</p>
                                <div className="d-flex btn-list btn-list-icon justify-content-center">
                                    <button type="button" className="btn btn-sm btn-primary">
                                        <i className="fe fe-user-plus me-1" />
                                        Follow
                                    </button>
                                    <button type="button" className="btn btn-sm btn-info">
                                        <i className="fe fe-message-square me-1" />
                                        Message
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-xxl-12 col-xl-8 col-lg-7 col-md-7">
                        <div className="card">
                            <div className="card-header">
                                <ul className="nav nav-pills gap-2" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="editprofile-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#editprofile"
                                            type="button"
                                            role="tab"
                                            aria-controls="editprofile"
                                            aria-selected="false"
                                        >
                                            Edit Profile
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="projects-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#projects"
                                            type="button"
                                            role="tab"
                                            aria-controls="projects"
                                            aria-selected="false"
                                        >
                                            Change Password
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-body p-0">
                                <div className="tab-content" id="pills-tabContent">

                                    <div className="tab-pane fade show active" id="editprofile">
                                        <UpdateProfile isEdit={null} />
                                    </div>
                                    <div className="tab-pane projects fade" id="projects">
                                        <ChangePassword />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ROW-1 CLOSED */}
            </div>

        </>
    );
};

export default MyProfile;